module.exports = __webpack_public_path__ + "static/media/academy-landing-foto-tablet-portrait.89b2aeb2.jpg";